import React from 'react';

import BuzzfeedFull from 'marketing-website/components/icons/BuzzfeedFull';
import CabifyFull from 'marketing-website/components/icons/CabifyFull';
import CookpadFull from 'marketing-website/components/icons/cookpadFull';
import DeliverooFull from 'marketing-website/components/icons/DeliverooFull';
import DesignMuseumFull from 'marketing-website/components/icons/DesignMuseumFull';
import HudlFull from 'marketing-website/components/icons/HudlFull';
import LaboratoriaFull from 'marketing-website/components/icons/LaboratoriaFull';
import ModeFull from 'marketing-website/components/icons/ModeFull';
import MonzoFull from 'marketing-website/components/icons/MonzoFull';
import NokiaFull from 'marketing-website/components/icons/NokiaFull';
import YieldrFull from 'marketing-website/components/icons/YieldrFull';
import TrusonaFull from 'marketing-website/components/icons/TrusonaFull';
import ZincFull from 'marketing-website/components/icons/ZincFull';

import buzzfeed from 'marketing-website/media/images/pages/customer-stories/buzzfeed@2x.jpg';
import cabify from 'marketing-website/media/images/pages/customer-stories/cabify@2x.jpg';
import cookpad from 'marketing-website/media/images/pages/customer-stories/cookpad@2x.jpg';
import deliveroo from 'marketing-website/media/images/pages/customer-stories/deliveroo@2x.jpg';
import designMuseum from 'marketing-website/media/images/pages/customer-stories/design-museum@2x.jpg';
import laboratoria from 'marketing-website/media/images/pages/customer-stories/laboratoria@2x.png';
import hudl from 'marketing-website/media/images/pages/customer-stories/hudl@2x.jpg';
import mode from 'marketing-website/media/images/pages/customer-stories/mode@2x.jpg';
import monzo from 'marketing-website/media/images/pages/customer-stories/monzo@2x.jpg';
import nokia from 'marketing-website/media/images/pages/case-studies/nokia/nokia-hero.jpg';
import yieldr from 'marketing-website/media/images/pages/customer-stories/yieldr@2x.jpg';
import trusona from 'marketing-website/media/images/pages/customer-stories/trusona@2x.jpg';
import zinc from 'marketing-website/media/images/pages/customer-stories/zinc@2x.jpg';

const customerStoriesItems = [
  {
    id: 0,
    title:
      'How Nokia uses Marvel to collaborate effectively across global teams',
    logo: <NokiaFull size={90} />,
    image: {
      alt:
        'How Nokia uses Marvel to collaborate effectively across global teams',
      src: nokia,
    },
    url: '/case-studies/nokia',
  },
  {
    id: 1,
    title: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
    logo: <CabifyFull size={90} />,
    image: {
      alt: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
      src: cabify,
    },
    url: '/case-studies/cabify',
  },
  {
    id: 2,
    title: 'How Marvel keeps Monzo shipping every two weeks',
    logo: <MonzoFull size={90} />,
    image: {
      alt: 'How Marvel keeps Monzo shipping every two weeks',
      maxWidth: 362,
      src: monzo,
    },
    url: '/case-studies/monzo',
  },
  {
    id: 3,
    title:
      "How Buzzfeed's design team created a single source of truth with Marvel",
    logo: <BuzzfeedFull size={90} />,
    image: {
      alt:
        "How Buzzfeed's design team created a single source of truth with Marvel",
      src: buzzfeed,
    },
    url: '/case-studies/buzzfeed',
  },
  {
    id: 4,
    title: 'How Hudl drive great UX through daily user testing with Marvel',
    logo: <HudlFull size={80} />,
    image: {
      alt: 'How Hudl drive great UX through daily user testing with Marvel',
      src: hudl,
    },
    url: '/case-studies/hudl',
  },
  {
    id: 5,
    title:
      'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
    logo: <YieldrFull size={70} />,
    image: {
      alt:
        'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
      maxWidth: 362,
      src: yieldr,
    },
    url: '/case-studies/yieldr',
  },
  {
    id: 6,
    title:
      'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
    logo: <TrusonaFull />,
    image: {
      alt:
        'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
      maxWidth: 362,
      src: trusona,
    },
    url: '/case-studies/trusona',
  },
  {
    id: 7,
    title: 'Why Zinc introduces Marvel to their incubator startups',
    logo: <ZincFull />,
    image: {
      alt: 'Why Zinc introduces Marvel to their incubator startups',
      maxWidth: 362,
      src: zinc,
    },
    url: '/case-studies/zinc',
  },
  {
    id: 8,
    title:
      'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
    logo: <CookpadFull width={120} height={35} />,
    image: {
      alt:
        'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
      maxWidth: 362,
      src: cookpad,
    },
    url: '/case-studies/cookpad',
  },
  {
    id: 9,
    title:
      'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
    logo: <DesignMuseumFull width={65} height={50} />,
    image: {
      alt:
        'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
      maxWidth: 362,
      src: designMuseum,
    },
    url: '/case-studies/designmuseum',
  },
  {
    id: 10,
    title: 'How Laboratoria’s students foster learning in design with Marvel',
    logo: <LaboratoriaFull size={130} />,
    image: {
      alt:
        'How Laboratoria’s students foster design learning in design with Marvel',
      maxWidth: 362,
      src: laboratoria,
    },
    url: '/case-studies/laboratoria',
  },
  {
    id: 11,
    title:
      'How Marvel Handoff transformed Mode’s design to development communication',
    logo: <ModeFull />,
    image: {
      alt:
        'How Marvel Handoff transformed Mode’s design to development communication',
      maxWidth: 400,
      src: mode,
    },
    url: '/case-studies/mode',
  },
  {
    id: 12,
    title:
      'How Deliveroo speed up iteration and drive great design with Marvel',
    logo: <DeliverooFull size={100} />,
    image: {
      alt:
        'How Deliveroo speed up iteration and drive great design with Marvel',
      src: deliveroo,
    },
    url: '/case-studies/deliveroo',
  },
];

export default customerStoriesItems;



// WEBPACK FOOTER //
// ./src/configs/customerStoriesItems.js